import { DownloadOutlined } from "@ant-design/icons";
import { Dropdown, MenuProps, message } from "antd";
import { DropdownButtonProps } from "antd/lib/dropdown";
import React from "react";
import {
  useLazyDownloadReconciliationGroupReportDocumentQuery,
  useLazyDownloadReconciliationGroupTitlesDocumentQuery
} from "../../../redux/api/reconciliationsApiSlice";
import { JOB_STATUS, ReconciliationGroup } from "../../../types/reconciliation";

export const DownloadReconciliationGroupFilesButton = ({reconciliationGroup, ...dropdownProps}:{reconciliationGroup: ReconciliationGroup} & DropdownButtonProps) => {
  const [messageApi, contextHolder] = message.useMessage();

  const [downloadTitles, {isLoading: isDownloadingReconciliationTitles}] = useLazyDownloadReconciliationGroupTitlesDocumentQuery();
  const [downloadReport, {isLoading: isDownloadingReconciliationReport}] = useLazyDownloadReconciliationGroupReportDocumentQuery();

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    switch (e.key) {
      case "FCS":
        console.log("scaricamento foglio cassa standardizzato");
        if (reconciliationGroup) {
          downloadTitles(reconciliationGroup.uuid).unwrap().catch((err: any) => {
            console.error("could not download statement titles due to an error: ", err);
            messageApi.error("Errore nel download del foglio cassa standardizzato.");
          });
        }
        break;
      case "REPORT":
        console.log("scaricamento esito riconciliazione");
        if (reconciliationGroup) {
          downloadReport(reconciliationGroup.uuid).unwrap().catch((err: any) => {
            console.error("could not download reconciliation report due to an error: ", err);
            messageApi.error("Errore nel download della riconciliazione.");
          });
        }
        break;
      default:
        break;
    }
  };

  return (
    <>
      {contextHolder}
      <Dropdown.Button
      type={"text"}
      loading={isDownloadingReconciliationReport || isDownloadingReconciliationTitles}
      icon={<DownloadOutlined />}
      menu={{
        items: [{
          key: "FCS",
          label: "Scarica Foglio Cassa Standardizzato"
        }, {
          key: "REPORT",
          label: "Scarica esito riconciliazione",
          disabled: isDownloadingReconciliationReport || isDownloadingReconciliationTitles || reconciliationGroup.reconciliation_job_status !== JOB_STATUS.DONE,
        }],
        onClick: handleMenuClick,
      }}
      {...dropdownProps}
    />
    </>
  );
};